<template>
  <div class="container">
    <el-container>
      <el-main>
        <el-header>我的足迹</el-header>
        <div>
<!--          <el-row  :gutter="20">-->
<!--            <el-col :span="10">-->
<!--              <div class="search">-->
<!--                <el-input-->
<!--                  placeholder="商品名称"-->
<!--                  v-model="keyword"-->
<!--                  class="input-with-select"-->
<!--                >-->
<!--                  <el-button-->
<!--                    slot="append"-->
<!--                    icon="el-icon-search"-->
<!--                    @click="searchFoot"-->
<!--                  ></el-button>-->
<!--                </el-input>-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </el-row>-->
          <div>
            <el-table
              :data="footRecords"
              border
              :header-cell-style="{textAlign:'center'}"
            >
              <el-table-column label="宝贝商品">
                <template slot-scope="scope">
                  <el-link :underline="false" @click="toProductDetail(scope.row.product)">
                    <div style="width: 100%;display: flex">
                      <div>
                        <img :src="scope.row.product.image"
                             style="width: 50px; height: 50px"
                        >
                      </div>
                      <div style="padding: 0 20px">
                        <p class="name">{{scope.row.product.storeName}}</p>
                      </div>
                    </div>
                  </el-link>
                </template>
              </el-table-column>
              <el-table-column width="300" label="足迹时间" prop="createTime">
              </el-table-column>
            </el-table>
          </div>
          <div class="block">
            <el-pagination
              background
              @current-change="queryFootPage"
              :current-page="page.current"
              :page-size="page.size"
              layout="prev, pager, next, jumper"
              :total="page.total">
            </el-pagination>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import api from '../../../api'
import {listSearchMixin} from '../../../config/mixin'
import {mapGetters, mapMutations} from 'vuex'

export default {
  mixins: [listSearchMixin],
  data(){
    return{
      keyword:'',
      footRecords:[

      ],
      page:{
        current:1,
        size:8,
        tatal:0,
      }
    }
  },
  computed:{
    ...mapGetters([
      'userInfo' // 用户信息
    ])
  },
  created() {
    this.queryFoot();
  },
  methods:{
    ...mapMutations({
      setCurrentPro: 'SET_CURRENTPRO'
    }),
    searchFoot(){

    },
    queryFootPage(e){
      this.page.current=e;
      this.queryFoot();
    },
    toProductDetail (item) {
      if (item.isShow==0){
        this.$message.warning("商品已下架");
        return;
      }
      console.log("--------------------")
      console.log(item)
      this.setCurrentPro(item)
      this.$router.push({path: '/productDetail'})
    },
    queryFoot(){
      let self=this;
      let params = {
        url: api.queryFoot + "?page=" + self.page.current + '&size=' + self.page.size,
        method: 'GET',
        data: {
        }
      }
      self.sendReq(params, (res) => {
        self.footRecords=res.data.content;
        self.page.total=res.data.totalElements;
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  border: 1px solid #E5E5E5;
  .el-row {
    width: 890px;
    margin-bottom: 20px;
    border-bottom: none !important;
    font-size: 15px;
    color: #99a9bf;
    padding-bottom: 10px;
  }
  .el-col {
    text-align: left !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/foot/foot.vue